import { render, staticRenderFns } from "./PersonnelVerify.vue?vue&type=template&id=6245e5b6&"
import script from "./PersonnelVerify.vue?vue&type=script&lang=js&"
export * from "./PersonnelVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports